import { CalendarDate, formatCurrency, FranchiseFeeStructureMode } from "@sp-crm/core";

let formKeyCounter = 0;
export function nextFormKey(): string {
    return `fk-${++formKeyCounter}`;
}

export function parseCents(dollars: string): number {
    const val = parseFloat(dollars);
    if (isNaN(val)) return 0;
    return Math.round(val * 100);
}

export function parseBasisPoints(percent: string): number {
    const val = parseFloat(percent);
    if (isNaN(val)) return 0;
    return Math.round(val * 100);
}

export function centsToDollarsInput(cents: number): string {
    return (cents / 100).toFixed(2);
}

export function basisPointsToPercentInput(basisPoints: number | null): string {
    if (basisPoints === null) {
        return "";
    }
    return (basisPoints / 100).toFixed(2);
}

export function formatDollars(cents: number): string {
    return formatCurrency(cents / 100);
}

export function modeChangePatch(
    currentFeePercentDisplay: string,
    newMode: FranchiseFeeStructureMode,
): { mode: FranchiseFeeStructureMode; feePercentDisplay: string } {
    return {
        mode: newMode,
        feePercentDisplay:
            newMode === FranchiseFeeStructureMode.FlatFee ? "" : currentFeePercentDisplay,
    };
}

export function feeStructureModeLabel(mode: FranchiseFeeStructureMode): string {
    switch (mode) {
        case FranchiseFeeStructureMode.FlatFee:
            return "Min Fee";
        case FranchiseFeeStructureMode.PercentPlusMinimum:
            return "Percent / Minimum";
        default: {
            const exhaustiveCheck: never = mode;
            throw new Error(`Unhandled fee structure mode: ${exhaustiveCheck}`);
        }
    }
}

export function feeScheduleLabel(mode: FranchiseFeeStructureMode): string {
    return mode === FranchiseFeeStructureMode.PercentPlusMinimum
        ? "Minimum fee schedule"
        : "Fee schedule";
}

export function feeAmountColumnLabel(mode: FranchiseFeeStructureMode): string {
    return mode === FranchiseFeeStructureMode.PercentPlusMinimum
        ? "Monthly minimum ($)"
        : "Monthly fee ($)";
}

export function stepWhenLabel(monthsAfterCommencement: number): string {
    if (monthsAfterCommencement === 0) {
        return "At commencement";
    }
    if (monthsAfterCommencement === 1) {
        return "After 1 month";
    }
    return `After ${monthsAfterCommencement} months`;
}

export function computeEffectiveDate(
    commencementDate: CalendarDate | null,
    monthsAfterCommencement: number,
): CalendarDate | null {
    if (!commencementDate) {
        return null;
    }
    return commencementDate.addMonths(monthsAfterCommencement);
}
